export default "__VITE_ASSET__fc896b4d__"